import React from "react";
import { Moment } from "moment";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { PickersDayProps } from "@mui/x-date-pickers/PickersDay/PickersDay";

import { DATE_FORMAT } from "../../../constants";

const StyledDatePicker = styled(MuiDatePicker<Moment>)({
  "& .MuiInputBase-input": {
    // width: 90,
  },
});

export type TRenderDay = (
  day: Moment,
  selectedDays: Moment[],
  pickersDayProps: PickersDayProps<Moment>
) => JSX.Element;

interface IProps {
  label: string;
  name: string;
  value: Moment | null;
  onChange: (value: Moment | null) => void;
  disabled?: boolean;
  maxDate?: Moment; // TODO use Moment
  minDate?: Moment;
  renderDay?: TRenderDay;
}

const DatePicker = ({
  label,
  name,
  value,
  onChange,
  disabled,
  ...rest
}: IProps): React.ReactElement => {
  return (
    <StyledDatePicker
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputFormat={DATE_FORMAT}
      // renderDay={rest.renderDay}
      {...(rest.maxDate && { maxDate: rest.maxDate })}
      {...(rest.minDate && { minDate: rest.minDate })}
      {...(rest.renderDay && { renderDay: rest.renderDay })}
      renderInput={(params) => <TextField name={name} fullWidth {...params} />}
    />
  );
};

export default DatePicker;
